var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "static-content" }, [
    _c("section", { staticClass: "static__first-screen" }, [
      _c("div", { staticClass: "first-screen__container" }, [
        _c(
          "div",
          { staticClass: "first-screen__content" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("landing.h1")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("landing.h1Cap")))]),
            _vm._v(" "),
            _c(
              "custom-button",
              {
                attrs: { animation: true },
                on: {
                  click: function() {
                    return _vm.handleNextStep(1, true)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("landing.startQuiz")) +
                    "\n        "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "first-screen__iphone" }, [
          _c("div", { staticClass: "iphone" }, [
            _c("img", {
              attrs: {
                src: _vm.mediaBaseUrl + "landing/benefits/iphone.png",
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "benefits",
              style: { left: -_vm.sliderLeft + "px" }
            },
            _vm._l(_vm.benefits, function(benefit) {
              return _c("div", { key: benefit, staticClass: "benefit" }, [
                _c("img", {
                  attrs: { src: _vm.mediaBaseUrl + benefit, alt: "" }
                })
              ])
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "features", attrs: { id: "features" } }, [
      _c("div", { staticClass: "features__container" }, [
        _c(
          "div",
          { staticClass: "features__content" },
          [
            _c("header", [
              _c("div", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("landing.features.title")))
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.$t("landing.features.caption")))]),
              _vm._v(" "),
              _c("div", { staticClass: "video" }, [
                _c(
                  "video",
                  {
                    staticClass: "lazy",
                    attrs: {
                      loop: "",
                      muted: "",
                      autoplay: "",
                      playsinline: ""
                    },
                    domProps: { muted: true }
                  },
                  [
                    _c("source", {
                      attrs: {
                        "data-src": _vm.mediaBaseUrl + "landing/features.mp4",
                        type: "video/mp4"
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "features__list" },
              _vm._l(_vm.features, function(feature) {
                return _c(
                  "div",
                  { key: feature.title, staticClass: "feature" },
                  [
                    _c("img", {
                      attrs: { src: _vm.mediaBaseUrl + feature.image, alt: "" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "feature__content" }, [
                      _c("h3", [_vm._v(_vm._s(feature.title))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(feature.text))])
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "custom-button",
              {
                attrs: { animation: true },
                on: {
                  click: function() {
                    return _vm.handleNextStep(4, true)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("landing.startQuiz")) +
                    "\n        "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "video" }, [
          _c(
            "video",
            {
              staticClass: "lazy",
              attrs: { loop: "", muted: "", autoplay: "", playsinline: "" },
              domProps: { muted: true }
            },
            [
              _c("source", {
                attrs: {
                  "data-src": _vm.mediaBaseUrl + "landing/features.mp4",
                  type: "video/mp4"
                }
              })
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "reviews__header" }, [
      _c("div", { staticClass: "header__container" }, [
        _c(
          "header",
          [
            _c("h2", [_vm._v(_vm._s(_vm.$t("landing.reviews.headerTitle")))]),
            _vm._v(" "),
            _c(
              "custom-button",
              {
                attrs: { animation: true },
                on: {
                  click: function() {
                    return _vm.handleNextStep(2)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("landing.startQuiz")) +
                    "\n        "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "reviews__statistics" }, [
          _c("div", { staticClass: "stat" }, [
            _c("div", { staticClass: "stat__number" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.stats[0].val")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat__name" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.stats[0].name")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat" }, [
            _c("div", { staticClass: "stat__number" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.stats[1].val")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat__name" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.stats[1].name")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat" }, [
            _c("div", { staticClass: "stat__number" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.stats[2].val")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat__name" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.stats[2].name")))
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "reviews", attrs: { id: "reviews" } }, [
      _c(
        "div",
        { staticClass: "reviews__container" },
        [
          _c("header", [
            _c("div", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("landing.reviews.title")))
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.$t("landing.reviews.caption")))])
          ]),
          _vm._v(" "),
          _c("reviews-list")
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "pre-footer" }, [
      _c("div", { staticClass: "pre-footer__container" }, [
        _c(
          "div",
          { staticClass: "pre-footer__content" },
          [
            _c("div", { staticClass: "rewards" }, [
              _c("div", { staticClass: "reward" }, [
                _c("img", {
                  attrs: {
                    src: _vm.mediaBaseUrl + "landing/reward-bg.png",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "reward__value" }, [
                  _vm._v(_vm._s(_vm.$t("landing.preFooter.rewards[0].val")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reward__name" }, [
                  _vm._v(_vm._s(_vm.$t("landing.preFooter.rewards[0].name")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "reward" }, [
                _c("img", {
                  attrs: {
                    src: _vm.mediaBaseUrl + "landing/reward-bg.png",
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "reward__value" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.mediaBaseUrl + "landing/apple.svg",
                      alt: "apple"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reward__name" }, [
                  _vm._v(_vm._s(_vm.$t("landing.preFooter.rewards[1].name")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("header", [
              _c("h2", [_vm._v(_vm._s(_vm.$t("landing.preFooter.title")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("landing.preFooter.caption")))])
            ]),
            _vm._v(" "),
            _c(
              "custom-button",
              {
                attrs: { animation: true },
                on: {
                  click: function() {
                    return _vm.handleNextStep(3)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("landing.startQuiz")) +
                    "\n        "
                )
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "faq", attrs: { id: "faq" } }, [
      _c(
        "div",
        { staticClass: "faq__container" },
        [
          _c("header", [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("landing.faq.title")))
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.$t("landing.faq.caption")))])
          ]),
          _vm._v(" "),
          _c("landing-faq")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }